import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';

import { HeartIcon, ClipboardCopyIcon, DocumentTextIcon, ArrowLeftIcon, SunIcon } from '@heroicons/react/outline'

//image
import defaultPng from '../../../../../../../../images/default.png'

const ProfileCard = ({ id, orgMembers, savedOrg, likedOrg, allProjects, setProjects, dailyProjects, setResult}) => {

    const [ indigo, setIndigo ] = useState("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 hover:bg-indigo-500")
    const [ red, setRed ] = useState("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 hover:bg-red-500")
    const [ green, setGreen ] = useState("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 hover:bg-green-500")
    const [ yellow, setYellow ] = useState("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 hover:bg-yellow-500")

    return (
      <div className="flex ">
        <div className="mr-4 flex-shrink-0">
          <img 
          style={{borderRadius:'20px'}}
          src={defaultPng} 
          alt='profilePng' 
          className="h-16 w-16 border border-gray-300 bg-white text-gray-300"
          />
        </div>
      
        <div >
            <h4 className="text-lg font-bold capitalize">{id}</h4>
            <h4 className="text-lg font-bold">Members:</h4>
            {orgMembers?.map((member, index)=> {
              return(
                <div key={index} className="flex flex-row flex-wrap mb-1">
                  <p className="text-sm text-gray-500 truncate ml-1" ><b>Name:</b> {member.firstName} {member.lastName}</p>
                  <p className="text-sm text-gray-500 truncate ml-1" ><b>Role:</b> {member.role}</p>
                  <p className="text-sm text-gray-500 truncate ml-1" ><b>Email:</b> {member.email}</p>
                </div>
                
              )
            })}
            
            <div className="mr-6 mt-2 flex flex-row ">
            <div className="mt-6 flex flex-wrap">
            <div className="mr-0 flex-shrink-0" >
                <DocumentTextIcon 
                style={{borderRadius:'10px'}} 
                className={indigo}
                aria-hidden="true" 
                onClick={()=>{
                  setProjects(allProjects); 
                  setIndigo("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 bg-indigo-500")
                  setRed("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                  setGreen("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                  setYellow("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                  setResult(false)
                }} 
                />
              </div>
              <div>
                <h4 className="text-base font-bold ">All messages</h4>
                <p className="mt-0.2 mr-1">
                  Total messages: {allProjects?.length}
                </p>
              </div>
              <div className="mr-0 flex-shrink-0" >
                <HeartIcon 
                style={{borderRadius:'10px'}} 
                className={red} //"h-12 w-12 border border-gray-300 bg-white text-gray-300 bg-red-700" 
                aria-hidden="true" 
                onClick={()=>{
                    setProjects(likedOrg);
                    setIndigo("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5"); 
                    setRed("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 bg-red-500");
                    setGreen("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                    setYellow("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                    setResult(false)
                  }} 
                />
              </div>
              <div>
                <h4 className="text-base font-bold mr-0.5">Liked messages</h4>
                <p className="mt-0.2 mr-1">
                  Total messages: {likedOrg?.length}
                </p>
              </div>
              <div className="mr-0 flex-shrink-0" >
                <ClipboardCopyIcon 
                style={{borderRadius:'10px'}} 
                className={green}
                aria-hidden="true" 
                onClick={()=>{
                  setProjects(savedOrg); 
                  setIndigo("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5"); 
                  setRed("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                  setGreen("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 bg-green-500");
                  setYellow("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                  setResult(false);
                }} 
                />
              </div>
              <div>
                <h4 className="text-base font-bold mr-0.5">Copied messages</h4>
                <p className="mt-0.2 mr-1">
                  Total messages: {savedOrg?.length}
                </p>
              </div>
              <div className="mr-0 flex-shrink-0" >
                <SunIcon 
                style={{borderRadius:'10px'}} 
                className={yellow}
                aria-hidden="true" 
                onClick={()=>{
                  setProjects(dailyProjects); 
                  setIndigo("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5"); 
                  setRed("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                  setGreen("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5");
                  setYellow("h-10 w-10 border border-gray-300 bg-white text-gray-300 mr-0.5 bg-yellow-500");
                  setResult(false)
                }} 
                />
              </div>
              <div>
                <h4 className="text-base font-bold mr-0.5">Daily messages</h4>
                <p className="mt-0.2 mr-1">
                  Total messages: {dailyProjects?.length}
                </p>
              </div>
            </div>
            </div>
            
        </div>
          <div className="-ml-7 flex-shrink-0" >
            <NavLink
            exact
            to={'/organizationsBound'}
            >
              <button
                type="button"
                className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <ArrowLeftIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
                Return
              </button>
            </NavLink>
          </div>
      </div>
    )
}

export default ProfileCard